import { CSSProperties, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import methodModel from "../../methods/methods";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { IoCheckmarkCircle } from "react-icons/io5";
import { MdPauseCircle, MdPlayCircle } from "react-icons/md";
import FormControl from "../../components/common/FormControl";
import { useParams } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import PopUp from "../../components/PopUp";
import { FiPlus } from "react-icons/fi";
import loader from "../../methods/loader";
import { RxCross2 } from "react-icons/rx";
import html2canvas from "html2canvas";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import CardAnimation from "../../components/CardAnimation";
import environment from "../../environment";
import PhoneInput from "react-phone-input-2";
import SelectDropdown from "../../components/common/SelectDropdown";

const CustomizeCard = ({
    cardDetail,
    setCardDetail,
    selectedCard,
    setSelectedCard,
    count,
    setcount,
    increasecount,
    decreasecount,
    getSelecteddata,
    handleAudioSelect,
    selectedAudio,
    isPlaying,
    handlePlayPause,
    setAudioRef,
}: any) => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [tab, setTab]: any = useState(0)
    const imageRef: any = useRef(null)
    // const receptionTextRef: any = useRef(null)
    const [submit, setSubmit] = useState(false)
    const [modal, setModal] = useState({ modal: false, message: "", image: "", buttonText: "" })
    const [showWaterMark, setShowWaterMark] = useState(true);

    const findPreViewTab = (tab: string) => {
        // const envelopeLength = cardDetail?.envelope_details?.length || 0
        const audioLength = cardDetail?.audioIds?.length || 0
        let number = 0
        let envelopeLength = 10
        if (tab === "Preview") {
            if (envelopeLength === 0 && audioLength === 0) {
                number = 2
            }
            else if (envelopeLength === 0 || audioLength === 0) {
                number = 3
            } else {
                number = 4
            }
        } else if (tab === "Envelope") {
            if (audioLength === 0) {
                number = 2
            } else {
                number = 3
            }
        } else return ""
        // if (tab === "Preview") {
        //     if (audioLength === 0) {
        //         number = 1
        //     } else {
        //         number = 2
        //     }
        // } else if (tab === "Envelope") {
        //     if (audioLength === 0) {
        //         number = 0
        //     } else {
        //         number = 1
        //     }
        // } else return ""
        return number
    }

    // const receptionTextElementStyle: CSSProperties = {
    //     position: 'absolute',
    //     top: `${selectedCard?.receptionTextPosition?.top}%`,
    //     right: `${selectedCard?.receptionTextPosition?.right}%`,
    //     fontSize: `${selectedCard?.receptionTextSize}px`,
    //     color: selectedCard?.receptionTextColor,
    //     height: 'auto',
    //     cursor: tab === findPreViewTab("Preview") ? "default" : "move",
    //     userSelect: 'none',
    //     textAlign: 'center',
    //     lineHeight: 'normal',
    // };
    // Left Side Card CSS
    const textElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.textPosition?.top}%`,
        right: `${cardDetail?.textPosition?.right}%`,
        fontSize: `${cardDetail?.textSize}px`,
        color: cardDetail?.textColor,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const imageElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.imagePosition?.top}%`,
        right: `${cardDetail?.imagePosition?.right}%`,
        width: `${cardDetail?.imageSize}%`,
        cursor: 'default',
    };
    const text2ElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.text2Position?.top}%`,
        right: `${cardDetail?.text2Position?.right}%`,
        fontSize: `${cardDetail?.text2Size}px`,
        color: cardDetail?.text2Color,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const stickerStampElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.stickerStampPosition?.top}%`,
        right: `${cardDetail?.stickerStampPosition?.right}%`,
        width: `${cardDetail?.stickerStampSize}%`,
        cursor: 'default',
    };
    const senderNameElementStyle: CSSProperties = {
        position: 'absolute',
        bottom: '1%',
        right: '0',
        fontSize: `${selectedCard?.senderTextSize}px`,
        color: selectedCard?.senderTextColor,
        height: 'auto',
    };

    // Right Side Card CSS
    const secondImageTextElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.secondImageTextPosition?.top}%`,
        right: `${cardDetail?.secondImageTextPosition?.right}%`,
        fontSize: `${cardDetail?.secondImageTextSize}px`,
        color: cardDetail?.secondImageTextColor,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const secondImageElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.secondImagePosition?.top}%`,
        right: `${cardDetail?.secondImagePosition?.right}%`,
        width: `${cardDetail?.secondImageSize}%`,
        cursor: 'default',
    };
    const secondImageText2ElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.secondImageText2Position?.top}%`,
        right: `${cardDetail?.secondImageText2Position?.right}%`,
        fontSize: `${cardDetail?.secondImageText2Size}px`,
        color: cardDetail?.secondImageText2Color,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const secondImageStickerStampElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${cardDetail?.secondImageStickerStampPosition?.top}%`,
        right: `${cardDetail?.secondImageStickerStampPosition?.right}%`,
        width: `${cardDetail?.secondImageStickerStampSize}%`,
        cursor: 'default',
    };

    // Text & Image drag and drop functionality handling through the arguments passing ref and key to get the position and set the selectedCard state
    // const [dragging, setDragging] = useState(false);
    // const [initialPos, setInitialPos] = useState({ x: 0, y: 0 });
    // const onDragStart = (e: any, ref: any) => {
    //     setDragging(true);
    //     const rect = ref.current.getBoundingClientRect();
    //     setInitialPos({
    //         x: e.clientX - rect.left,
    //         y: e.clientY - rect.top
    //     });
    // };
    // const onDrag = (e: any, ref: any, key: any) => {
    //     if (dragging) {
    //         const imageRect = imageRef.current.getBoundingClientRect();
    //         const dummyTextRect = ref.current.getBoundingClientRect();
    //         let newX = e.clientX - initialPos.x - imageRect.left;
    //         let newY = e.clientY - initialPos.y - imageRect.top;
    //         // Constrain within parent boundaries
    //         if (newX < 0) {
    //             newX = 0;
    //         } else if (newX + dummyTextRect.width > imageRect.width) {
    //             newX = imageRect.width - dummyTextRect.width;
    //         }
    //         if (newY < 0) {
    //             newY = 0;
    //         } else if (newY + dummyTextRect.height > imageRect.height) {
    //             newY = imageRect.height - dummyTextRect.height;
    //         }
    //         // Calculate percentage positions
    //         const percentTop: any = (newY / imageRect.height) * 100;
    //         const percentRight: any = ((imageRect.width - newX - dummyTextRect.width) / imageRect.width) * 100;

    //         setSelectedCard((prev: any) => ({
    //             ...prev,
    //             [key]: {
    //                 top: parseFloat(percentTop).toFixed(2),
    //                 right: parseFloat(percentRight).toFixed(2)
    //             }
    //         }))
    //     }
    // };
    // const onDragEnd = (e: any) => {
    //     setDragging(false);
    // };

    const generateImages = async () => {
        const capturedImages: (string | null)[] = [];
        for (let i = 0; i < 4; i++) {
            setcount(i);
            await new Promise(resolve => setTimeout(resolve, 2000));

            if (imageRef.current) {
                const canvas = await html2canvas(imageRef.current, {
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: null,
                    scale: window.devicePixelRatio * 2, // Increase scale for higher resolution
                });
                // Convert canvas directly to Blob
                await new Promise<void>((resolve) => {
                    canvas.toBlob(async (blob) => {
                        if (!blob) {
                            capturedImages.push(null);
                            return resolve();
                        }
                        // Create file from blob
                        const file = new File([blob], `captured_image_${i}.png`, { type: "image/png" });
                        // Upload to server
                        try {
                            const res = await ApiClient.postFormData('upload/image', { file });
                            capturedImages.push(res?.fileName || null);
                        } catch (err) {
                            capturedImages.push(null);
                        }
                        resolve();
                    }, "image/png");
                });
            }
        }
        return capturedImages;
    };

    const handleCheckout = async () => {
        setSubmit(true)
        setShowWaterMark(false)
        if (!selectedCard?.recipient_name || !selectedCard?.type || (selectedCard?.type === "email" && (!selectedCard?.recipient_email || !validateEmail(selectedCard?.recipient_email))) || (selectedCard?.type === "sms" && !selectedCard?.recipient_mobileNo)) {
            const findEnvelopeTab = findPreViewTab("Envelope")
            setTab(findEnvelopeTab)
            setShowWaterMark(true)
            return
        }
        loader(true)
        const findEnvelopeTab = findPreViewTab("Envelope")
        setTab(findEnvelopeTab)
        const capturedImages = await generateImages();
        if (capturedImages?.length < 4) {
            setModal({ modal: true, message: "Something went wrong try again.", image: "/assets/img/warning.png", buttonText: "Ok" })
            loader(false)
            setSubmit(false)
            setShowWaterMark(true)
            return
        }
        const payload = {
            envelopeId: selectedCard?.envelope?._id,
            cardId: id,
            audioId: selectedCard?.audio?._id,
            price: cardDetail?.price,
            quantity: 1,
            tag: selectedCard?.tag,
            recipient_name: selectedCard?.recipient_name,
            type: selectedCard?.type,
            recipient_email: selectedCard?.recipient_email,
            recipient_dialCode: selectedCard?.recipient_dialCode || "",
            recipient_mobileNo: selectedCard?.recipient_mobileNo || "",
            capturedImages: capturedImages,
            sender_name: selectedCard?.sender_name,
            sender_nameColor: selectedCard?.senderTextColor,
            sender_nameSize: selectedCard?.senderTextSize,
            // receptionTextColor: selectedCard?.receptionTextColor,
            // receptionTextSize: selectedCard?.receptionTextSize,
            receptionTextPosition: selectedCard?.receptionTextPosition,
            images: selectedCard?.images,
            customizeCardDetail: cardDetail,
        }
        if (selectedCard?.type === "email") {
            delete payload.recipient_dialCode
            delete payload.recipient_mobileNo
        } else {
            delete payload.recipient_email
        }
        ApiClient.post(`cart/add`, payload).then(res => {
            if (res.success) {
                navigate(`/checkout`)
            }
            loader(false)
        })
    }

    // Handle upload image and set image path on key (getting through the parameters) of cardDetail state
    const ImageUpload = (e: any, key: string) => {
        let files = e.target.files
        let file = files.item(0)
        loader(true)
        ApiClient.postFormData('upload/image', { file: file }).then(res => {
            if (res.success) {
                setCardDetail({ ...cardDetail, [key]: res?.fileName })
            }
            loader(false)
        })
    }

    const validateEmail = (email: any) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const hasEnvelopeValidationErrors = () => {
        return !selectedCard?.recipient_name
            || !selectedCard?.sender_name
            || !selectedCard?.type
            || (selectedCard?.type === "email" && (!selectedCard?.recipient_email || !validateEmail(selectedCard?.recipient_email)))
            || (selectedCard?.type === "sms" && !selectedCard?.recipient_mobileNo)
    };

    const waterMark = () => {
        if (showWaterMark) {
            return <div className="absolute inset-0 pointer-events-none grid grid-cols-4 grid-rows-4 gap-4" style={{ opacity: 0.1 }}>
                {Array(16).fill(0).map((_, i) => (
                    <span key={i} className="text-primary text-4xl font-bold select-none transform -rotate-45 flex items-center justify-center">
                        FRUM ME 2 U
                    </span>
                ))}
            </div>
        } else {
            return ""
        }
    }

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'align': [] }], // 👈 alignment options: left, center, right, justify
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean']
        ]
    };

    const handleChangePhone = (phone: any, country: any) => {
        const dialCode = country?.dialCode
        setSelectedCard((prev: any) => ({ ...prev, recipient_dialCode: dialCode, recipient_mobileNo: phone?.replace(dialCode, "") }))
    }

    const handleNextClick = () => {
        const envelopeTab = Number(findPreViewTab("Envelope"))
        const previewTab = Number(findPreViewTab("Preview"))

        if (tab === envelopeTab && hasEnvelopeValidationErrors()) {
            setSubmit(true)
            return
        }

        if (tab < previewTab) {
            setTab(tab + 1)
            return
        }

        handleCheckout()
    }

    return (
        <>
            <div className="section-custamzied px-4 lg:px-16 pt-6 lg:pt-12">
                <div className="flex flex-col items-center w-full gap-6">
                    <div className="w-full items-center px-8 rounded-xl shadow justify-between gap-4">
                        <TabGroup selectedIndex={tab} onChange={(e: any) => setTab(e)}>
                            <TabList className="flex items-center p-8 rounded-xl shadow justify-between bg-white gap-6 lg:gap-12 xl:gap-20">
                                <div className="flex items-center gap-16">
                                    <Tab key="EditText">
                                        <div className={`items_child text-center cursor-pointer group ${tab === 0 && "text-primary"}`}>
                                            <div className="relative h-6">
                                                <img src={`/assets/img/ed/icons/${tab === 0 ? "c11" : "c1"}.svg`} className="mx-auto" />
                                            </div>
                                            <p className="mt-1">Edit Text</p>
                                        </div>
                                    </Tab>
                                    <Tab key="Graphics">
                                        <div className={`items_child text-center cursor-pointer group ${tab === 1 && "text-primary"}`}>
                                            <div className="relative h-6">
                                                <img src={`/assets/img/ed/icons/${tab === 1 ? "3" : "s3"}.svg`} className="mx-auto" />
                                            </div>
                                            <p className="mt-1">Graphics</p>
                                        </div>
                                    </Tab>
                                    {cardDetail?.audio_details?.length > 0 ? // Tab === 2
                                        <Tab key="ChangeMusic">
                                            <div className={`items_child text-center cursor-pointer group ${tab === 0 && "text-primary"}`}>
                                                <div className="relative h-6">
                                                    <img src={`/assets/img/ed/icons/${tab === 0 ? "c33" : "c3"}.svg`} className="mx-auto" />
                                                </div>
                                                <p className="mt-1">Change Music</p>
                                            </div>
                                        </Tab>
                                        : null}
                                    {/* {cardDetail?.envelope_details?.length > 0 ? */}
                                    <Tab key="Envelope">
                                        <div className={`items_child text-center cursor-pointer group ${tab === findPreViewTab("Envelope") && "text-primary"}`}>
                                            <div className="relative h-6">
                                                <img src={`/assets/img/ed/icons/${tab === findPreViewTab("Envelope") ? "1" : "s1"}.svg`} className="mx-auto" />
                                            </div>
                                            <p className="mt-1">Envelope</p>
                                        </div>
                                    </Tab>
                                    {/* : null} */}
                                </div>
                                <div className="flex items-center gap-6 lg:gap-12 xl:gap-20">
                                    <Tab key="Preview">
                                        <div className={`items_child text-center cursor-pointer group ${tab === findPreViewTab("Preview") && "text-primary"}`}>
                                            <div className="relative h-6">
                                                <img src={`/assets/img/ed/icons/${tab === findPreViewTab("Preview") ? "2" : "s2"}.svg`} className="mx-auto" />
                                            </div>
                                            <p className="mt-1">Preview</p>
                                        </div>
                                    </Tab>
                                    <button type="button" onClick={handleNextClick} className="bg-primary px-6 py-3 text-xl w-28 text-white rounded-xl">Next</button>
                                </div>
                            </TabList>
                            <TabPanels className="mt-3">
                                <div className="mt-6 lg:mt-16 mb-10">
                                    <div className={`${tab === findPreViewTab("Preview") ? "max-w-[800px] mx-auto" : "grid grid-cols-12 gap-6"}`}>
                                        {tab === findPreViewTab("Preview") ? null :
                                            <div className="col-span-12 lg:col-span-6">
                                                <TabPanel key="EditText">
                                                    <ul>
                                                        <li key="EditText" className="relative rounded-md text-sm/6 transition">
                                                            <div className="bg-white rounded-xl shadow-lg p-6">
                                                                <h6 className="text-[26px] text-gray-800 font-normal">Text</h6>
                                                                <div className="inputs_wraps mt-6">
                                                                    <div className="mb-3">
                                                                        <label>Text {cardDetail?.text2 && "1"}</label>
                                                                        <ReactQuill theme="snow" value={cardDetail?.text} onChange={(content) => { setCardDetail((prev: any) => ({ ...prev, text: content })); setcount(1); }} className="w-full" modules={modules} />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label>Text {cardDetail?.text2 && "1"} Size</label>
                                                                        <div className="mb-3">
                                                                            <div className="flex items-center align-center">
                                                                                <input type="range" value={cardDetail?.textSize} onChange={(e: any) => { setCardDetail((prev: any) => ({ ...prev, textSize: e.target.value })); setcount(1); }} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                                                                                <span>{cardDetail?.textSize}px</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {cardDetail?.text2 &&
                                                                        <>
                                                                            <div className="mb-3">
                                                                                <label>Text 2</label>
                                                                                <ReactQuill theme="snow" value={cardDetail?.text2} onChange={(content) => { setCardDetail((prev: any) => ({ ...prev, text2: content })); setcount(1); }} className="w-full" modules={modules} />
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <label>Text 2 Size</label>
                                                                                <div className="mb-3">
                                                                                    <div className="flex items-center align-center">
                                                                                        <input type="range" value={cardDetail?.text2Size} onChange={(e: any) => { setCardDetail((prev: any) => ({ ...prev, text2Size: e.target.value })); setcount(1); }} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                                                                                        <span>{cardDetail?.text2Size}px</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </TabPanel>
                                                <TabPanel key="Graphics">
                                                    <ul>
                                                        <li key="Graphics" className="relative rounded-md text-sm/6 transition">
                                                            <div className="bg-white rounded-xl shadow-lg p-6">
                                                                <h6 className="text-[26px] text-gray-800 font-normal">Graphics</h6>
                                                                <div className="my-3">
                                                                    <label>Text {cardDetail?.text2 && "1"} Color</label>
                                                                    <div className="mb-3">
                                                                        <div className="flex items-center align-center">
                                                                            <input type="color" value={cardDetail?.textColor} onChange={(e: any) => { setCardDetail((prev: any) => ({ ...prev, textColor: e.target.value })); setcount(1); }} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {cardDetail?.text2 &&
                                                                    <div className="my-3">
                                                                        <label>Text 2 Color</label>
                                                                        <div className="mb-3">
                                                                            <div className="flex items-center align-center">
                                                                                <input type="color" value={cardDetail?.text2Color} onChange={(e: any) => { setCardDetail((prev: any) => ({ ...prev, text2Color: e.target.value })); setcount(1); }} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </TabPanel>
                                                {cardDetail?.audio_details?.length > 0 ?
                                                    <TabPanel key="ChangeMusic">
                                                        <ul>
                                                            <li key="ChangeMusic" className="relative rounded-md text-sm/6 transition">
                                                                <div className="bg-white rounded-xl shadow-lg p-6">
                                                                    <h6 className="text-[26px] text-gray-800 font-normal">Change Music</h6>
                                                                    <div className=" max-h-96 overflow-y-auto overflow-x-hidden mt-4 flex flex-col onlyscroll gap-4 pr-6">
                                                                        {cardDetail && cardDetail?.audio_details.map((audio: any, index: number) => (
                                                                            <div key={index} className="p-2 flex justify-between items-center gap-4 cursor-pointer bg-gray-100" onClick={e => handleAudioSelect(audio, index)}>
                                                                                <div className="flex items-center gap-4">
                                                                                    <img src="/assets/img/music.jpg" className="h-16 w-16 object-cover rounded-xl" />
                                                                                    <h4 className="text-[20px] font-normal">{audio?.title}</h4>
                                                                                </div>
                                                                                <div className="flex items-center gap-4">
                                                                                    {selectedAudio === index && <IoCheckmarkCircle className="text-3xl text-primary" />}
                                                                                    {selectedAudio === index && isPlaying ?
                                                                                        <>
                                                                                            <img src="/assets/img/ed/music.gif" className="h-12" />
                                                                                            <MdPauseCircle className="text-3xl cursor-pointer" onClick={() => handlePlayPause(index)} />
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <MdPlayCircle className="text-3xl cursor-pointer" onClick={() => handlePlayPause(index)} />
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                                <audio ref={(ref) => {
                                                                                    if (index === selectedAudio) {
                                                                                        setAudioRef(ref);
                                                                                    }
                                                                                }} controls style={{ display: 'none' }}>
                                                                                    <source src={`${methodModel.audio(audio?.audio)}`} type="audio/mp3" />
                                                                                </audio>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </TabPanel>
                                                    : null}
                                                {/* {cardDetail?.envelope_details?.length > 0 ? */}
                                                <TabPanel key="Envelope">
                                                    <ul>
                                                        <li key="Envelope" className="relative rounded-md text-sm/6 transition">
                                                            <div className="bg-white rounded-xl shadow-lg p-6">
                                                                <div className="mb-3">
                                                                    <h6 className="text-[26px] text-gray-800 font-normal">Recipient Detail</h6>
                                                                    <div className="my-4">
                                                                        <label>Recipient Name</label>
                                                                        <div className="mb-3">
                                                                            <div className="flex items-center align-center">
                                                                                <input type="text" value={selectedCard?.recipient_name} onChange={e => setSelectedCard((prev: any) => ({ ...prev, recipient_name: e.target.value }))} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Enter Recipient Name" />
                                                                            </div>
                                                                            {submit && !selectedCard?.recipient_name ? <p className="text-red-600">Recipient name is required</p> : null}
                                                                        </div>
                                                                        <label>Invitation Type</label>
                                                                        <div className="mb-3">
                                                                            <SelectDropdown
                                                                                id="statusDropdown"
                                                                                displayValue="name"
                                                                                className="mt-1 capitalize"
                                                                                placeholder="Select Invitation Type"
                                                                                theme="search"
                                                                                intialValue={selectedCard?.type}
                                                                                result={(e: any) => setSelectedCard((prev: any) => ({ ...prev, type: e.value }))}
                                                                                isClearable={false}
                                                                                options={[
                                                                                    { id: "email", name: "Email" },
                                                                                    { id: "sms", name: "Mobile Number" },
                                                                                ]}
                                                                            />
                                                                            {submit && !selectedCard?.type ? <p className="text-red-600">Invitation type is required</p> : null}
                                                                        </div>
                                                                        {selectedCard?.type === "email" &&
                                                                            <>
                                                                                <label>Recipient Email</label>
                                                                                <div className="mb-3">
                                                                                    <div className="flex items-center align-center">
                                                                                        <input type="email" value={selectedCard?.recipient_email} onChange={e => setSelectedCard((prev: any) => ({ ...prev, recipient_email: e.target.value }))} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Enter Recipient Email" />
                                                                                    </div>
                                                                                    {submit && !selectedCard?.recipient_email ? (
                                                                                        <p className="text-red-600">Recipient email is required</p>
                                                                                    ) : submit && selectedCard?.recipient_email && !validateEmail(selectedCard?.recipient_email) ? (
                                                                                        <p className="text-red-600">Please enter a valid email address</p>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        {selectedCard?.type === "sms" &&
                                                                            <>
                                                                                <label>Mobile Number</label>
                                                                                <div className="mb-3">
                                                                                    <PhoneInput
                                                                                        country={"us"}
                                                                                        value={selectedCard?.recipient_mobileNo ? selectedCard?.recipient_dialCode + selectedCard?.recipient_mobileNo : null}
                                                                                        enableSearch={true}
                                                                                        // disableDropdown={true}
                                                                                        // countryCodeEditable={false}
                                                                                        inputProps={{ required: true, autoComplete: "one-time-code" }}
                                                                                        onChange={(phone: string, country: string) => handleChangePhone(phone, country)}
                                                                                    />
                                                                                    {submit && !selectedCard?.recipient_mobileNo ? <p className="text-red-600">Mobile Number is required</p> : null}
                                                                                </div>
                                                                            </>
                                                                        }

                                                                        {/* <label>Recipient Text Color</label>
                                                                                <div className="mb-3">
                                                                                    <div className="flex items-center align-center">
                                                                                        <input type="color" value={selectedCard?.receptionTextColor} onChange={e => setSelectedCard((prev: any) => ({ ...prev, receptionTextColor: e.target.value }))} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                                                                                    </div>
                                                                                </div>
                                                                                <label>Recipient Text Size</label>
                                                                                <div className="mb-3">
                                                                                    <div className="flex items-center align-center">
                                                                                        <input type="range" value={selectedCard?.receptionTextSize} onChange={e => setSelectedCard((prev: any) => ({ ...prev, receptionTextSize: e.target.value }))} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                                                                                        <span>{selectedCard?.receptionTextSize}px</span>
                                                                                    </div>
                                                                                </div> */}
                                                                        <label>Sender Name</label>
                                                                        <div className="mb-3">
                                                                            <div className="flex items-center align-center">
                                                                                <input type="email" value={selectedCard?.sender_name} onChange={e => setSelectedCard((prev: any) => ({ ...prev, sender_name: e.target.value }))} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Enter Sender Name" />
                                                                            </div>
                                                                            {submit && !selectedCard?.sender_name ? <p className="text-red-600">Sender name is required</p> : null}
                                                                        </div>
                                                                        <label>Sender Text Color</label>
                                                                        <div className="mb-3">
                                                                            <div className="flex items-center align-center">
                                                                                <input type="color" value={selectedCard?.senderTextColor} onChange={e => setSelectedCard((prev: any) => ({ ...prev, senderTextColor: e.target.value }))} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                                                                            </div>
                                                                        </div>
                                                                        <label>Sender Text Size</label>
                                                                        <div className="mb-3">
                                                                            <div className="flex items-center align-center">
                                                                                <input type="range" value={selectedCard?.senderTextSize} onChange={e => setSelectedCard((prev: any) => ({ ...prev, senderTextSize: e.target.value }))} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                                                                                <span>{selectedCard?.senderTextSize}px</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <h6 className="text-[26px] text-gray-800 font-normal">More Style</h6>
                                                                    <div className="flex gap-4 xl:gap-6 flex-wrap mt-10">
                                                                        {cardDetail && cardDetail?.envelope_details.map((item: any, index: number) => (
                                                                            <img onClick={() => getSelecteddata(item)} src={methodModel.noImg(`${item?.front_image}`)} key={index} className={`${item?._id === selectedCard?.envelope?._id ? "border border-primary rounded-md" : "bg-white"} h-32 w-32 object-contain cursor-pointer`} />
                                                                        ))}
                                                                    </div> */}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </TabPanel>
                                                {/* // : null} */}
                                            </div>
                                        }
                                        {tab === findPreViewTab("Preview") ?
                                            <div className="col-span-12 lg:col-span-6">
                                                <div className="w-full">
                                                    <CardAnimation detail={{ ...cardDetail, ...selectedCard }} />
                                                </div>
                                            </div>
                                            :
                                            <div className="col-span-12 lg:col-span-6">
                                                {/* {selectedCard?.images?.length == 0 ?
                                                    <>
                                                        <div className="bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] w-full p-2 rounded-xl border border-gray-200" style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", display: count === 0 ? "" : "none" }} >
                                                            <div className="flex items-center justify-center relative">
                                                                <img src={methodModel.noImg(`${cardDetail?.image}`)} className="h-full mx-auto object-contain" id="image" />
                                                                {waterMark()}
                                                                <div style={textElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: cardDetail?.text }}></div>
                                                                {cardDetail?.stickerImage && <img style={imageElementStyle} src={cardDetail?.stickerImage ? methodModel.userImg(cardDetail?.stickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                                {cardDetail?.text2 && <div style={text2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: cardDetail?.text2 }}></div>}
                                                                {cardDetail?.stickerStamp && <img style={stickerStampElementStyle} src={methodModel.noImg(cardDetail?.stickerStamp)} className={`p-1`} />}
                                                                {selectedCard?.sender_name && <div style={senderNameElementStyle} className="capitalize mx-2">{selectedCard?.sender_name}</div>}
                                                                {(count > 0) && !submit ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                                {(count < 1) && !submit ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                            </div>
                                                        </div>
                                                        <div className="bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] w-full p-2 rounded-xl border border-gray-200" style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", display: count === 1 ? "" : "none" }} >
                                                            <div className="flex items-center justify-center relative">
                                                                <img src={methodModel.noImg(`${cardDetail?.secondImage}`)} className="h-full mx-auto object-contain" id="image" />
                                                                {waterMark()}
                                                                <div style={secondImageTextElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: cardDetail?.secondImageText }}></div>
                                                                {cardDetail?.secondImageStickerImage && <img style={secondImageElementStyle} src={cardDetail?.secondImageStickerImage ? methodModel.userImg(cardDetail?.secondImageStickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                                {cardDetail?.secondImageText2 && <div style={secondImageText2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: cardDetail?.secondImageText2 }}></div>}
                                                                {cardDetail?.secondImageStickerStamp && <img style={secondImageStickerStampElementStyle} src={methodModel.noImg(cardDetail?.secondImageStickerStamp)} className={`p-1`} />}
                                                                {selectedCard?.sender_name && <div style={senderNameElementStyle} className="capitalize mx-2">{selectedCard?.sender_name}</div>}
                                                                {(count > 0) && !submit ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                                {(count < 1) && !submit ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                            </div>
                                                        </div>
                                                    </>
                                                    : */}
                                                <>
                                                    <div className="bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] w-full p-2 rounded-xl border border-gray-200" style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", display: count === 0 ? "" : "none" }} >
                                                        <div className="flex items-center justify-center relative overflow-hidden h-full" ref={count === 0 ? imageRef : null}>
                                                            <img src={methodModel.noImg(`${selectedCard?.images[count]}`)} className="h-full mx-auto object-contain" id="image" />
                                                            {/* {selectedCard?.sender_name && <div style={senderNameElementStyle} className="capitalize mx-2">{selectedCard?.sender_name}</div>} */}
                                                            {(count > 0) && !submit ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                            {(count < 3) && !submit ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] w-full p-2 rounded-xl border border-gray-200" style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", display: count === 1 ? "" : "none" }} >
                                                        <div className="flex items-center justify-center relative overflow-hidden" ref={count === 1 ? imageRef : null}>
                                                            <img src={methodModel.noImg(`${selectedCard?.images[count]}`)} className="h-full mx-auto object-contain" id="image" />
                                                            {waterMark()}
                                                            <div style={textElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: cardDetail?.text }}></div>
                                                            {cardDetail?.stickerImage && <img style={imageElementStyle} src={cardDetail?.stickerImage ? methodModel.userImg(cardDetail?.stickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                            {cardDetail?.text2 && <div style={text2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: cardDetail?.text2 }}></div>}
                                                            {cardDetail?.stickerStamp && <img style={stickerStampElementStyle} src={methodModel.noImg(cardDetail?.stickerStamp)} className={`p-1`} />}
                                                            {/* {selectedCard?.sender_name && <div style={senderNameElementStyle} className="capitalize mx-2">{selectedCard?.sender_name}</div>} */}
                                                            {(count > 0) && !submit ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                            {(count < 3) && !submit ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] w-full p-2 rounded-xl border border-gray-200" style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", display: count === 2 ? "" : "none" }} >
                                                        <div className="flex items-center justify-center relative overflow-hidden" ref={count === 2 ? imageRef : null}>
                                                            <img src={methodModel.noImg(`${selectedCard?.images[count]}`)} className="h-full mx-auto object-contain" id="image" />
                                                            {waterMark()}
                                                            <div style={secondImageTextElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: cardDetail?.secondImageText }}></div>
                                                            {cardDetail?.secondImageStickerImage && <img style={secondImageElementStyle} src={cardDetail?.secondImageStickerImage ? methodModel.userImg(cardDetail?.secondImageStickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                            {cardDetail?.secondImageText2 && <div style={secondImageText2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: cardDetail?.secondImageText2 }}></div>}
                                                            {cardDetail?.secondImageStickerStamp && <img style={secondImageStickerStampElementStyle} src={methodModel.noImg(cardDetail?.secondImageStickerStamp)} className={`p-1`} />}
                                                            {selectedCard?.sender_name && <div style={senderNameElementStyle} className="capitalize mx-2">{selectedCard?.sender_name}</div>}
                                                            {(count > 0) && !submit ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                            {(count < 3) && !submit ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] w-full p-2 rounded-xl border border-gray-200" style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", display: count === 3 ? "" : "none" }} >
                                                        <div className="flex items-center justify-center relative overflow-hidden" ref={count === 3 ? imageRef : null}>
                                                            <img src={selectedCard?.images[count] ? methodModel.noImg(`${selectedCard?.images[count]}`) : "/assets/img/white-screen.jpg"} className="h-full mx-auto object-contain" id="image" />
                                                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                                                <div className="relative w-64 h-64">
                                                                    <img src="/assets/img/black_heart.png" alt="Heart" className="w-full h-full object-contain" />
                                                                    <p className="absolute inset-0 flex items-center justify-center -top-12 text-black text-center text-sm font-semibold py-4 px-6">
                                                                        Touching One Heart At A Time
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="absolute bottom-3 left-4 transform text-white text-sm text-right px-2">
                                                                <p className="text-md font-semibold text-gray-900"><span className='text-md'>©</span> Copyright</p>
                                                            </div>
                                                            <div className="absolute bottom-3 right-4 transform text-white text-sm text-right px-2">
                                                                <p className="text-lg font-semibold text-gray-900">FRUM ME 2 U</p>
                                                                <p className="text-[12px] font-medium text-gray-800">{environment.frontendUrl}</p>
                                                            </div>
                                                            {(count > 0) && !submit ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                            {(count < 3) && !submit ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                        </div>
                                                    </div>
                                                </>
                                                {/* } */}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </TabPanels>
                        </TabGroup>
                    </div>
                </div>
            </div>
            <PopUp popUp={modal} setPopUp={setModal} />
            <div className="hidden">
                <img src={methodModel.noImg(`${cardDetail?.image}`)} className="h-[100px] mx-auto object-contain" />
                <img src={methodModel.noImg(`${cardDetail?.secondImage}`)} className="h-[100px] mx-auto object-contain" />
                <img src={methodModel.noImg(`${selectedCard?.images[0]}`)} className="h-[100px] mx-auto object-contain" />
                <img src={methodModel.noImg(`${selectedCard?.images[1]}`)} className="h-[100px] mx-auto object-contain" />
                <img src={methodModel.noImg(`${selectedCard?.images[2]}`)} className="h-[100px] mx-auto object-contain" />
                <img src={methodModel.noImg(`${selectedCard?.images[3]}`)} className="h-[100px] mx-auto object-contain" />
            </div>
        </>
    )
}

export default CustomizeCard
